import { Component, OnInit } from '@angular/core';
import { TCEmbeddedModeService } from '@cloud-twin-v2/cloud-twin-shared/core/embedded-mode.service';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { SelectedWorkspaceService } from '@cloud-twin-v2/cloud-twin-shared/selected-workspace.service';
import { SidePanelService } from '@cloud-twin-v2/side-panel/side-panel.service';
import { MenuLink } from '@common-modules/navigation/models/menu-link';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

const COMPONENT_SELECTOR = 'tc-main-top-bar';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './main-top-bar.component.html',
  styleUrls: ['./main-top-bar.component.scss'],
  standalone: false,
})
export class MainTopBarComponent implements OnInit {
  disabledRightPanelButtons: boolean;
  readonly homeMenuLink = new MenuLink({
    urlPath: '/',
    svgIcon: 'home',
    isSvg: true,
  });
  readonly titleKey = 'core.app-title';
  readonly T_SCOPE = `${TranslateScopes.MainLayout}.${COMPONENT_SELECTOR}`;

  get rightPanelVisibility(): Observable<boolean> {
    return this._panelService.visibility$;
  }

  get rightPanelHover(): Observable<boolean> {
    return this._panelService.hover$;
  }

  readonly embeddedMode$: Observable<boolean>;

  constructor(
    private readonly _panelService: SidePanelService,
    private readonly _embeddedModeService: TCEmbeddedModeService,
    private readonly _selectedWorkspaceService: SelectedWorkspaceService
  ) {
    this.embeddedMode$ = this._embeddedModeService.isEmbedded$;
  }

  toggleVisibility = () => this._panelService.toggleVisibility();
  toggleHover = () => this._panelService.toggleHover();

  ngOnInit(): void {
    this._panelService.hasPanel$
      .pipe(untilDestroyed(this))
      .subscribe((hasRightPanel) => (this.disabledRightPanelButtons = !hasRightPanel));
  }

  onSelectedWorkspaceRemove() {
    this._selectedWorkspaceService.setWorkspace(null);
  }
}
